import LayoutHR from "layouts/layout-hr";
import React from "react";
import { useNavigate } from "react-router-dom";
import { URLS } from "utils/constants";
import PermissionMiddleware from "middleware/PermissionMiddleware";
import { HR_ASSET_VIEW_PERMISSIONS } from "utils/hrPermissionKeys";
import {
  IconBuilding,
  IconPackage,
  IconShield,
  IconHome,
  IconMinus,
  IconUsersGroup,
  IconClock,
} from "@tabler/icons-react";

const MasterPage = () => {
  const navigate = useNavigate();

  const menuItems = [
    {
      title: "Asset Group",
      description: "Manage asset categories and groups",
      icon: IconPackage,
      path: URLS.v1.HR_MASTER_ASSET_GROUP,
      color: "primary",
      permissions: HR_ASSET_VIEW_PERMISSIONS,
    },
    {
      title: "Asset Item",
      description: "Manage individual assets and items",
      icon: IconBuilding,
      path: URLS.v1.HR_MASTER_ASSET_ITEM,
      color: "success",
      permissions: HR_ASSET_VIEW_PERMISSIONS,
    },
    {
      title: "Insurance",
      description: "Manage insurance policies",
      icon: IconShield,
      path: URLS.v1.HR_MASTER_INSURANCE,
      color: "danger",
    },
    {
      title: "Facility",
      description: "Manage office facilities",
      icon: IconHome,
      path: URLS.v1.HR_MASTER_FACILITY,
      color: "secondary",
    },
    {
      title: "Deduction",
      description: "Manage salary deductions",
      icon: IconMinus,
      path: URLS.v1.HR_MASTER_DEDUCTION,
      color: "dark",
    },
    {
      title: "Departments",
      description: "Manage company departments",
      icon: IconUsersGroup,
      path: URLS.v1.HR_MASTER_DEPARTMENTS,
      color: "info",
    },
    // {
    //   title: "Positions",
    //   description: "Manage job positions",
    //   icon: IconMilitaryRank,
    //   path: URLS.v1.HR_MASTER_POSITIONS,
    //   color: "warning",
    // },
    {
      title: "Shifts",
      description: "Manage work shifts",
      icon: IconClock,
      path: URLS.v1.HR_MASTER_SHIFTS,
      color: "success",
    },
    // {
    //   title: "Holidays",
    //   description: "Manage national and company holidays",
    //   icon: IconCalendarEvent,
    //   path: URLS.v1.HR_MASTER_HOLIDAYS,
    //   color: "danger",
    // },
  ];

  return (
    <LayoutHR>
      <div className="container-xl">
        {/* Page Header */}
        <div className="page-header d-print-none">
          <div className="row align-items-center">
            <div className="col">
              <h2 className="page-title">HR Master Data</h2>
              <div className="text-muted mt-1">
                Manage master data for HR operations
              </div>
            </div>
          </div>
        </div>

        {/* Menu Cards */}
        <div className="row row-deck row-cards">
          {menuItems.map((item, index) => {
            const IconComponent = item.icon;
            const menuCard = (
              <div key={index} className="col-sm-6 col-lg-3 mb-4">
                <div className="card card-hover">
                  <div className="card-body text-center">
                    <div
                      className={`avatar avatar-xl mb-3 bg-${item.color}-lt`}
                    >
                      <IconComponent
                        size={32}
                        className={`text-${item.color}`}
                      />
                    </div>
                    <h3 className="card-title mb-2">{item.title}</h3>
                    <p className="text-muted mb-3">{item.description}</p>
                    <button
                      className={`btn btn-${item.color} w-100`}
                      onClick={() => navigate(item.path)}
                    >
                      Manage 
                      {/* {item.title} */}
                    </button>
                  </div>
                </div>
              </div>
            );

            if (!item.permissions) return menuCard;

            return (
              <PermissionMiddleware key={index} allowedPermissions={item.permissions}>
                {menuCard}
              </PermissionMiddleware>
            );
          })}
        </div>
      </div>
    </LayoutHR>
  );
};

export default MasterPage;
